module.exports = __webpack_public_path__ + "cf2e4701b6bdcc5fca8c3de3f7abb474.pdf";